<template>
    <div class="pacman-container">
        <div class="v-spinner" v-bind:style="{position: 'relative', fontSize: 0}" v-show="loading">
            <div class="pacman">
                <div class="pacman-top"></div>
                <div class="pacman-bottom"></div>
            </div>
            <div class="v-pacman v-pacman2" v-bind:style="[spinnerStyle,animationStyle,spinnerDelay2]"/>
            <div class="v-pacman v-pacman3" v-bind:style="[spinnerStyle,animationStyle,spinnerDelay3]"/>
            <div class="v-pacman v-pacman4" v-bind:style="[spinnerStyle,animationStyle,spinnerDelay4]"/>
            <div class="v-pacman v-pacman5" v-bind:style="[spinnerStyle,animationStyle,spinnerDelay5]"/>
        </div>
        <p>{{message}}</p>
    </div>
</template>

<script>
    export default {
        name: 'PacmanLoader',

        props: {
            loading: {
                type: Boolean,
                default: true
            },
            color: {
                type: String,
                default: '#5dc596'
            },
            size: {
                type: String,
                default: '25px'
            },
            margin: {
                type: String,
                default: '2px'
            },
            radius: {
                type: String,
                default: '100%'
            },
            message: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                spinnerDelay2: {
                    animationDelay: '0.5s'
                },
                spinnerDelay3: {
                    animationDelay: '1s'
                },
                spinnerDelay4: {
                    animationDelay: '1.5s'
                },
                spinnerDelay5: {
                    animationDelay: '2s'
                }
            }
        },
        computed: {
            spinnerStyle() {
                return {
                    backgroundColor: this.color,
                    width: this.size,
                    height: this.size,
                    margin: this.margin,
                    borderRadius: this.radius,
                }
            },
            border1() {
                return this.size + ' solid black'
            },
            border2() {
                return this.size + ' solid ' + this.color
            },
            spinnerStyle1() {
                return {
                    width: 0,
                    height: 0,
                    borderTop: this.border2,
                    borderRight: this.border1,
                    borderBottom: this.border2,
                    borderLeft: this.border2,
                    borderRadius: this.size
                }
            },
            animationStyle() {
                return {
                    width: '10px',
                    height: '10px',
                    transform: 'translate(0, ' + -parseFloat(this.size) / 4 + 'px)',
                    position: 'absolute',
                    top: '25px',
                    left: '300px',
                    animationName: 'v-pacmanStretchDelay',
                    animationDuration: '2s',
                    animationIterationCount: 'infinite',
                    animationTimingFunction: 'linear',
                    animationFillMode: 'both'
                }
            }
        }

    }
</script>

<style>

    .v-spinner {
        text-align: center;
        margin: 15px auto;
        display: inline-block;
        padding-right: 300px;
    }

    .pacman-top {
        background-color: #5dc596;
        height: 25px;
        width: 50px;
        border-radius: 100px 100px 0 0;
        animation: spin1 0.5s infinite linear;
    }

    .pacman-bottom {
        background-color: #5dc596;
        height: 25px;
        width: 50px;
        border-radius: 0 0 100px 100px;
        animation: spin2 0.5s infinite linear;
    }

    /*TODO computed transform */
    @-webkit-keyframes v-pacmanStretchDelay {
        0% {
            -webkit-opacity: 0;
            opacity: 0;
        }
        30% {
            -webkit-opacity: 1;
            opacity: 1;
        }
        100% {
            -webkit-transform: translate(-300px, -6.25px);
            transform: translate(-300px, -6.25px);
        }
    }

    @keyframes v-pacmanStretchDelay {
        0% {
            -webkit-opacity: 0;
            opacity: 0;
        }
        30% {
            -webkit-opacity: 1;
            opacity: 1;
        }
        100% {
            -webkit-transform: translate(-300px, -6.25px);
            transform: translate(-300px, -6.25px);
        }
    }


    @-webkit-keyframes spin1 {
        0% {
            transform: rotate(0deg);
        }
        50% {
            transform: rotate(-35deg);
        }

    }

    @-webkit-keyframes spin2 {
        0% {
            transform: rotate(0deg);
        }
        50% {
            transform: rotate(35deg);
        }
    }

    @keyframes spin1 {
        0% {
            transform: rotate(0deg);
        }
        50% {
            transform: rotate(-35deg);
        }

    }

    @keyframes spin2 {
        0% {
            transform: rotate(0deg);
        }
        50% {
            transform: rotate(35deg);
        }
    }
</style>
